var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3284 8.66355C13.3284 11.9957 10.9959 13.6618 8.22355 14.6281C8.07838 14.6773 7.92069 14.6749 7.77705 14.6214C4.99803 13.6618 2.66553 11.9957 2.66553 8.66355V3.99854C2.66553 3.82179 2.73574 3.65228 2.86072 3.5273C2.9857 3.40232 3.15521 3.33211 3.33196 3.33211C4.66482 3.33211 6.33089 2.53239 7.49048 1.51942C7.63167 1.39879 7.81127 1.33252 7.99697 1.33252C8.18267 1.33252 8.36227 1.39879 8.50345 1.51942C9.66971 2.53906 11.3291 3.33211 12.662 3.33211C12.8387 3.33211 13.0082 3.40232 13.1332 3.5273C13.2582 3.65228 13.3284 3.82179 13.3284 3.99854V8.66355Z",
    stroke: "#155DFC",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.289a084e6bcaea864fd092ff39f3b617.svg";
export { ForwardRef as ReactComponent };